/* eslint-disable */
import React from 'react';
import { faCheck, faEye, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectMatchBlobByIndex, setFocusedBlobId, updateUserFeedback, upsertCorrectness } from '../../reducer/blobsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

interface IProps {
  index: number;
  id: string;
  feedback_id: string;
  correctness?: boolean;
}

export const ActionButtons = ({ index, id, feedback_id, correctness }: IProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const setIsCorrect = (correctness: boolean) => () => {
    dispatch(updateUserFeedback({ feedback_id, feedback_value: correctness }))
      .then(unwrapResult)
      .then(() => dispatch(upsertCorrectness({ index, correctness })))
      .catch((error) => console.error('Failed to update user feedback', error));
  };
  const setFocusedBlob = (focusedBlobId: string) => () => {
    dispatch(setFocusedBlobId(focusedBlobId));
  };

  return (
    <ButtonGroup>
      <Button variant="light" onClick={setFocusedBlob(id)}>
        <FontAwesomeIcon icon={faEye} className="rounded-circle bg-black text-white p-2" />
        <p>Im Dokument anzeigen</p>
      </Button>
      <Button
        variant={correctness === true ? 'success' : 'light'}
        onClick={setIsCorrect(true)}
      >
        <FontAwesomeIcon icon={faCheck} className="rounded-circle bg-black text-white p-2" />
        <p>Vorschlag annehmen</p>
      </Button>
      <Button
        variant={correctness === false ? 'danger' : 'light'}
        onClick={setIsCorrect(false)}
      >
        <FontAwesomeIcon icon={faXmark} className="rounded-circle bg-black text-white p-2" />
        <p>Vorschlag ablehnen</p>
      </Button>
    </ButtonGroup>
  );
};
